import { CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusGeneralLayout extends Layout {
    citystateCustomer: CityState;
    citystateFrom: CityState;
    citystateStatusCity: CityState;
    citystateTo: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    imageIsResend: Image;
    labelBLNumber: Label;
    labelBOL: Label;
    labelBillTo: Label;
    labelCarrier: Label;
    labelCarrierLabel: Label;
    labelConsigneeRefNo: Label;
    labelConsigneeReferenceNumber: Label;
    labelCustomerId: Label;
    labelCustomerName: Label;
    labelIntercompany: Label;
    labelIntercompanyYes: Label;
    labelReferenceNumbers: Label;
    labelStatusPicture: Label;
    panelCustomer: Panel;
    panelError: Panel;
    panelImage: Panel;
    panelOverview: Panel;
    panelPartnerInfo: Panel;
    panelStopOverview: Panel;
    panelTransmit: Panel;
    sourceCarrierPayee: DataSource;
    sourceCarriersForAssignment: DataSource;
    sourceCustomer: DataSource;
    sourceEdistatus: DataSource;
    textboxErrorCode: Textbox;
    textboxPartner: Textbox;
    textboxReadyToSend: Textbox;
    textboxShipmentId: Textbox;
    textboxStatusCodeDescription: Textbox;
    textboxTransmitted: Textbox;
}
